import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [inputs, setInputs] = useState({ type: "all" });
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true); 

    try {
      const res = await Http.get(`/product-list/${inputs.type}`);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); 
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
        Http.get("/product-list/" + value).then((res) => {
      setReceiveData(res.data);
    });
  };

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const formSubmit = () => {
    Http.get("/product-list/" + inputs.type).then((res) => {
      setReceiveData(res.data);
    });
  };
  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    { field: "section_type", header: "Section Type" },
    { field:(rowData) => {if(rowData.type === "raw_materials"){
      return "Raw Materials";
    }
    else if(rowData.type === "packing_materials"){
      return "Packing Materials";
    }
    else if(rowData.type === "finished_goods"){
      return "Finished Goods";
    }}
      , header: "Type" },
    { field: "unit_name", header: "Unit" },
    { field: "price", header: "Price" },
    { field: "sku", header: "SKU" },
    { field: "pack_size", header: "Pack Size" },
    { field: "stockQty", header: "Stock" },
    { field: "category.name", header: "Category" },
    { field: "status", header: "Status" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All product</h5>
            <Link to="/create-product" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i> New
            </Link>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-md-6 offset-md-3">
                  <div className="row">
                    <div className="col-lg-6 mx-auto">
                      <select
                        className="form-control"
                        name="type"
                        value={inputs.type}
                        onChange={handleChange}
                      >
                        <option value="all">All Products</option>
                        <option value="raw_materials">Raw Materials</option>
                        <option value="packing_materials">
                          Packing Materials
                        </option>
                        <option value="finished_goods">Finished Goods</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const actionTemplate = (item, deleteData) => {
  return (
    <td className="text-xs">
      <Link
        to={{ pathname: "/edit-product/" + item.id }}
        className="btn btn-primary btn-sm me-1"
        title="Edit"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link>
      <Link
        to={{ pathname: "/product-ledger/" + item.id }}
        className="btn btn-info  btn-sm"
        title="Product Ledger"
      >
        <i className="fa fa-list ms-1" aria-hidden="true"></i>
      </Link>
      <button
        className="btn btn-danger btn-sm ms-1"
        onClick={() => deleteData(item.id, "product", "product")}
        title="Delete"
      >
        <i className="fa fa-trash"></i>
      </button>
    </td>
  );
};
export default List;
